import { useState } from 'react'

import { BulkCreateAuthenticationInvitationDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'
import { handleResult } from 'modules/core/lib/handleMutation'
import app, { FlashType } from 'modules/core/store/models/app'

const showFlashMessage = (type: FlashType, message: string) => {
  app.setFlash({
    type,
    message,
  })
}

export const useSendInvitation = (employeeId: number) => {
  const { company } = useCurrentSession()
  const [invitationSent, setInvitationSent] = useState(false)
  const [invitationSentToUsers, setInvitationSentToUsers] = useState<number[]>([])

  const [bulkCreateInvitation] = useMutation(BulkCreateAuthenticationInvitationDocument, {
    extractorFn: (data) =>
      data.authenticationMutations.bulkCreateAuthenticationInvitation,
  })

  useEffect(() => {
    setInvitationSent(false)
  }, [employeeId])

  const { running, performAction } = useAsyncAction(async () => {
    const result = await bulkCreateInvitation({
      variables: {
        companyId: company.id,
        employeeIds: [employeeId],
      },
    })

    const handled = handleResult(result, () => {})

    if (handled.success) {
      setInvitationSent(true)
      setInvitationSentToUsers([...invitationSentToUsers, employeeId])
      showFlashMessage('correct', i18n.t('employees.invitation_sent'))
    }
  })

  return {
    invitationSent,
    invitationSentToUsers,
    running,
    performAction,
  }
}
